import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})

export class PreloaderService {

  loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingMap: Map<string, boolean> = new Map<string, boolean>();

  constructor(
    private notificationService: NotificationService
  ) {}
  // For auto enabled loading before any api call
  // It keeps loading till api call don't reach any result, next, or error
  // Here Url is being stored in a Map(string,boolean)



  setLoading = (loading: boolean, url: string): void => {
    if (!url) {
      this.notificationService.showError('The request URL is null...', 'Preloader Error')
      throw new Error('The request URL must be provided to the PreloaderService.setLoading function');
    }
    if (loading === true) {
      this.loadingMap.set(url, loading);
      this.loadingSub.next(true);
    } else if (loading === false && this.loadingMap.has(url)) {
      this.loadingMap.delete(url);
    }
    if (this.loadingMap.size === 0) {
      this.loadingSub.next(false);
    }
  }
}
// hritvik
